<template>
  <div class="settings">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <div class="col-sm-12">
                    <h3 class="page-title">Monitoring AI</h3>
                  </div>
                </div>
              </div>
              <!-- /Page Header -->
              <!-- {{this.profileArr}} -->
              <!-- {{ aiBalance. }} -->
              <form @submit.prevent="setupKey" class="was-validated">
                <div class="row" v-if="aiBalance.is_available == true || dataParam.api_key != ''">
                  <div class="col-sm-3">
                  </div>
                  <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                    <div class="card dash-widget">
                      <div class="card-body">
                        <span class="dash-widget-icon">
                          <i class="fa fa-asterisk"></i>
                        </span>
                        <div class="dash-widget-info">
                          <h3>
                            Token
                          </h3>
                          <span>
                            {{ calculateToken() }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                    <div class="card dash-widget">
                      <div class="card-body">
                        <span class="dash-widget-icon">
                          <i class="fa fa-signal"></i>
                        </span>
                        <div class="dash-widget-info">
                          <h3>
                            Status
                          </h3>
                          <span class="text text-success" v-if="aiBalance.is_available == true">
                            <i class="fa fa-check"></i> Available
                          </span>
                          <span class="text text-danger" v-else>
                            <i class="fa fa-remove"></i> Not Available
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3">
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>
                        API Key
                        <span class="text-danger">*</span>
                      </label>
                      <input class="form-control" type="text" v-model="dataParam.api_key" required />
                    </div>
                  </div>
                  <div class="col-sm-3">
                  </div>
                </div>
                <div class="row" v-show="false">
                  <div class="col-sm-3">
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>
                        Model
                        <span class="text-danger">*</span>
                      </label>
                      <select v-model="dataParam.ai_engine" class="form-control">
                        <option v-for="(row, index) in AiModels" :key="index" :value="row.id"
                          :disabled="(row.status == false) ? true : false">{{ row.label }}
                          {{ ((row.status == false) ? ' | Coming Soon...' : '') }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-3">
                  </div>
                </div>
                <div class="submit-section">
                  <button :disabled="isLoading" class="btn btn-primary submit-btn" @click="setupKey(true)">Save</button>
                  <!-- <button :disabled="isLoading" class="btn btn-primary submit-btn" @click="setupKey(true)">Save &amp;
                    Redirect</button> -->
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
import { nFormatter } from "@/utils/helper";

export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion
  },
  data() {
    return {
      pricePerUsd: 0.0000001647, //base on deepseek
      aiBalance: {
        is_available: false,
        balance_infos: [
          {
            currency: "USD",
            total_balance: "0",
            granted_balance: "0.00",
            topped_up_balance: "0.00"
          }
        ]
      },
      isLoading: false,
      dataParam: {
        api_key: "",
        ai_engine: "deepseek"
      },
      AiModels: [
        {
          id: "deepseek",
          label: "DeepSeek",
          status: true
        },
        {
          id: "gpt-4",
          label: "GPT-4",
          status: false
        },
        {
          id: "gpt-4o",
          label: "GPT-4o",
          status: false
        },
        {
          id: "gpt-4o-mini",
          label: "GPT-4o Mini",
          status: false
        },
        {
          id: "gpt-o1",
          label: "GPT-o1",
          status: false
        },
        {
          id: "gpt-o3",
          label: "GPT-o3",
          status: false
        },
        {
          id: "gpt-o3",
          label: "GPT-o3-mini",
          status: false
        },
        {
          id: "gpt-4.5",
          label: "GPT-4.5",
          status: false
        },
      ],
    };
  },
  created() {
    // console.log("xx")
    this.getAIKey();
    this.getBalance();
  },
  methods: {
    nFormatter(value) {
      return nFormatter(value);
    },
    calculateToken() {
      let total = parseFloat(this.aiBalance.balance_infos[0].total_balance) / this.pricePerUsd;
      return this.nFormatter(total)
    },

    setupKey(isRedirect = false) {
      this.isLoading = true;
      this.$store
        .dispatch("aiKey/setupKey", this.dataParam)
        .then(response => {
          this.isLoading = false;
          let { data } = response;
          this.$fire({
            title: "Success",
            text: "Data berhasil disimpan",
            type: "success",
            timer: 2000
          });
          this.getBalance();
          // if (isRedirect == true) {
          //   this.$router.push("/farm-contact/list")
          // }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getAIKey() {
      // console.log("geetttt")
      this.isLoading = true;
      this.$store
        .dispatch("aiKey/getAIKey")
        .then(response => {
          this.isLoading = false;
          let { data } = response;
          this.dataParam.api_key = data
        })
        .catch(err => {
          // console.log("errr",err)
          this.isLoading = false;
        });
    },
    getBalance() {
      // console.log("geetttt")
      this.isLoading = true;
      this.$store
        .dispatch("aiKey/getBalance")
        .then(response => {
          this.isLoading = false;
          let { data } = response;
          this.aiBalance = data
        })
        .catch(err => {
          // console.log("errr",err)
          this.isLoading = false;
        });
    },
  },
  mounted() {
  },
  name: "settingsAIKey"
};
</script>


// WEBPACK FOOTER //
// src/views/settings/aiKeyEdit.vue